var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-new": _vm.$userInfo.isSupportUser,
              "show-print": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("pnet-message-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "article",
                  { staticClass: "box" },
                  [
                    _c(
                      "div",
                      { staticClass: "tabs is-toggle is-toggle-rounded" },
                      [
                        _c("ul", [
                          _c(
                            "li",
                            {
                              class: {
                                "is-active":
                                  _vm.filter.messageStatusId ==
                                  _vm.messageStatusTypes.UnRead,
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.tabClicked(
                                        _vm.messageStatusTypes.UnRead
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._m(0),
                                  _c("span", [
                                    _c("span", { class: _vm.unreadOffset }, [
                                      _vm._v("Unread"),
                                    ]),
                                    _vm.countSummaries
                                      ? _c("span", {
                                          staticClass:
                                            "has-badge-rounded has-badge-medium",
                                          class: [
                                            _vm.filter.messageStatusId ==
                                            _vm.messageStatusTypes.UnRead
                                              ? "has-badge-info"
                                              : "has-badge-dark",
                                          ],
                                          attrs: {
                                            "data-badge": _vm.getCount(
                                              _vm.messageStatusTypes.UnRead
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "li",
                            {
                              class: {
                                "is-active":
                                  _vm.filter.messageStatusId ==
                                  _vm.messageStatusTypes.Read,
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.tabClicked(
                                        _vm.messageStatusTypes.Read
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._m(1),
                                  _c("span", [
                                    _c("span", { class: _vm.readOffset }, [
                                      _vm._v("Read"),
                                    ]),
                                    _vm.countSummaries
                                      ? _c("span", {
                                          staticClass:
                                            "has-badge-rounded has-badge-medium",
                                          class: [
                                            _vm.filter.messageStatusId ==
                                            _vm.messageStatusTypes.Read
                                              ? "has-badge-info"
                                              : "has-badge-dark",
                                          ],
                                        })
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "li",
                            {
                              class: {
                                "is-active":
                                  _vm.filter.messageStatusId ==
                                  _vm.messageStatusTypes.ToSend,
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.tabClicked(
                                        _vm.messageStatusTypes.ToSend
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._m(2),
                                  _c("span", [
                                    _c("span", { class: _vm.toSendOffset }, [
                                      _vm._v("To Send"),
                                    ]),
                                    _vm.countSummaries
                                      ? _c("span", {
                                          staticClass:
                                            "has-badge-rounded has-badge-medium",
                                          class: [
                                            _vm.filter.messageStatusId ==
                                            _vm.messageStatusTypes.ToSend
                                              ? "has-badge-info"
                                              : "has-badge-dark",
                                          ],
                                          attrs: {
                                            "data-badge": _vm.getCount(
                                              _vm.messageStatusTypes.ToSend
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "li",
                            {
                              class: {
                                "is-active":
                                  _vm.filter.messageStatusId ==
                                  _vm.messageStatusTypes.Sent,
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.tabClicked(
                                        _vm.messageStatusTypes.Sent
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._m(3),
                                  _c("span", [
                                    _c("span", { class: _vm.sentOffset }, [
                                      _vm._v("Sent"),
                                    ]),
                                    _vm.countSummaries
                                      ? _c("span", {
                                          staticClass:
                                            "has-badge-rounded has-badge-medium",
                                          class: [
                                            _vm.filter.messageStatusId ==
                                            _vm.messageStatusTypes.Sent
                                              ? "has-badge-info"
                                              : "has-badge-dark",
                                          ],
                                        })
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "li",
                            {
                              class: {
                                "is-active":
                                  _vm.filter.messageStatusId ==
                                  _vm.messageStatusTypes.Deleted,
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.tabClicked(
                                        _vm.messageStatusTypes.Deleted
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._m(4),
                                  _c("span", [
                                    _c("span", { class: _vm.deletedOffset }, [
                                      _vm._v("Deleted"),
                                    ]),
                                    _vm.countSummaries
                                      ? _c("span", {
                                          staticClass:
                                            "has-badge-rounded has-badge-medium",
                                          class: [
                                            _vm.filter.messageStatusId ==
                                            _vm.messageStatusTypes.Deleted
                                              ? "has-badge-info"
                                              : "has-badge-dark",
                                          ],
                                        })
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "tags has-addons",
                            staticStyle: { "margin-left": "auto" },
                          },
                          [
                            _c("span", { staticClass: "tag is-dark" }, [
                              _vm._v("Last fetched"),
                            ]),
                            !_vm.isTableLoading
                              ? _c("span", { staticClass: "tag is-success" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatDateTimeLocale(
                                        new Date(),
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "total-rows": _vm.totalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(_vm.entitySummaries, function (entity, index) {
                          return _c(
                            "tr",
                            {
                              key: entity.messageId,
                              class: {
                                "is-selected": _vm.selectedRow === index,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelected(index, $event)
                                },
                              },
                            },
                            [
                              _c(
                                "td",
                                {
                                  class: {
                                    "has-text-danger":
                                      entity.statusId ===
                                      _vm.messageStatusTypes.Failed,
                                  },
                                },
                                [
                                  _vm.canEditMessage
                                    ? _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { path: entity.messageId },
                                            append: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(entity.messageType) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(_vm._s(entity.messageType)),
                                      ]),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                {
                                  class: {
                                    "has-text-danger":
                                      entity.statusId ===
                                      _vm.messageStatusTypes.Failed,
                                  },
                                },
                                [_vm._v(" " + _vm._s(entity.regoNo) + " ")]
                              ),
                              _c(
                                "td",
                                {
                                  class: {
                                    "has-text-danger":
                                      entity.statusId ===
                                      _vm.messageStatusTypes.Failed,
                                  },
                                },
                                [_vm._v(" " + _vm._s(entity.claimNo) + " ")]
                              ),
                              _c(
                                "td",
                                {
                                  class: {
                                    "has-text-danger":
                                      entity.statusId ===
                                      _vm.messageStatusTypes.Failed,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(entity.customerName) + " "
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  class: {
                                    "has-text-danger":
                                      entity.statusId ===
                                      _vm.messageStatusTypes.Failed,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(entity.quoteRequestNo) + " "
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  class: {
                                    "has-text-danger":
                                      entity.statusId ===
                                      _vm.messageStatusTypes.Failed,
                                  },
                                },
                                [_vm._v(" " + _vm._s(entity.uid) + " ")]
                              ),
                              _c(
                                "td",
                                {
                                  class: {
                                    "has-text-danger":
                                      entity.statusId ===
                                      _vm.messageStatusTypes.Failed,
                                  },
                                },
                                [_vm._v(" " + _vm._s(entity.quoteNo) + " ")]
                              ),
                              _c(
                                "td",
                                {
                                  class: {
                                    "has-text-danger":
                                      entity.statusId ===
                                      _vm.messageStatusTypes.Failed,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(entity.vehicleDescription) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  class: {
                                    "has-text-danger":
                                      entity.statusId ===
                                      _vm.messageStatusTypes.Failed,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$filters.formatDateTimeLocale(
                                          entity.createdDate,
                                          _vm.$userInfo.locale
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("td", { staticClass: "is-content-width" }, [
                                _c(
                                  "div",
                                  { staticClass: "has-text-centered" },
                                  [
                                    _vm.canEditMessage
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "button is-primary is-small is-inverted tooltip is-tooltip-topright",
                                            attrs: {
                                              to: { path: entity.messageId },
                                              "data-tooltip": "View/Edit XML",
                                              append: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon is-medium" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-lead-pencil mdi-24px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.canLoadMessage
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-success is-small is-inverted tooltip is-tooltip-topright",
                                            attrs: {
                                              "data-tooltip": "Load Message",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.load(index)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon is-medium" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-download mdi-24px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.canMarkMessageRead
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-info is-small is-inverted tooltip is-tooltip-topright",
                                            attrs: {
                                              "data-tooltip": "Mark as Read",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showMessageActionConfirmModal(
                                                  entity.messageId,
                                                  _vm.messageStatusTypes.Read
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon is-medium" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-email-open mdi-24px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.canPrintMessage(entity.messageTypeId)
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-black is-small is-inverted tooltip is-tooltip-topright",
                                            attrs: {
                                              "data-tooltip": "Print Message",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.print(
                                                  entity.messageId,
                                                  entity.messageTypeId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon is-medium" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-printer mdi-24px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.canMarkMessageUnread
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-info is-small is-inverted tooltip is-tooltip-topright",
                                            attrs: {
                                              "data-tooltip": "Mark as Unread",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.markMessageAsUnread(
                                                  entity.messageId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon is-medium" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-email mdi-24px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.canResendMessage(entity.statusId)
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-link is-small is-inverted tooltip is-tooltip-topright",
                                            attrs: {
                                              "data-tooltip": "Resend Message",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.markMessageAsToSend(
                                                  entity.messageId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v("> "),
                                            _c(
                                              "span",
                                              { staticClass: "icon is-medium" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-send mdi-24px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.canDeleteMessage
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-danger is-small is-inverted tooltip is-tooltip-topright",
                                            attrs: {
                                              "data-tooltip": "Delete Message",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showMessageActionConfirmModal(
                                                  entity.messageId,
                                                  _vm.messageStatusTypes.Deleted
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon is-medium" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-delete mdi-24px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.canUndeleteMessage
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-danger is-small is-inverted tooltip is-tooltip-topright",
                                            attrs: {
                                              "data-tooltip": [
                                                entity.messageDirection === 0
                                                  ? "Restore to Read"
                                                  : "Restore to Sent",
                                              ],
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unDeleteMessage(
                                                  entity.messageId,
                                                  entity.messageDirection
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "icon is-medium" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-delete-restore mdi-24px",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c(
            "load-quote-modal",
            {
              attrs: {
                active: _vm.isLoadQuoteModalActive,
                "show-icon": false,
                "previous-disabled":
                  _vm.currentStep === _vm.steps.CreateAssign.id,
                "next-disabled":
                  _vm.currentStep === _vm.lastStep.id ||
                  !_vm.enableLoadQuoteNext,
                "continue-disabled": !_vm.enableContinue,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isLoadQuoteModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
                previous: function ($event) {
                  return _vm.previous()
                },
                next: function ($event) {
                  return _vm.next()
                },
                load: function ($event) {
                  return _vm.loadMessage()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("PNET Load Quote"),
              ]),
              _c(
                "div",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c("load-quote-steps", {
                    attrs: {
                      "current-step": _vm.currentStep,
                      steps: _vm.steps,
                      "ecom-type": "pnet",
                    },
                    model: {
                      value: _vm.loadOptions,
                      callback: function ($$v) {
                        _vm.loadOptions = $$v
                      },
                      expression: "loadOptions",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.gotoQuote(true)
                },
                cancel: function ($event) {
                  return _vm.gotoQuote(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Go to Quote"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm.savedLoadOptions &&
                  _vm.savedLoadOptions.isCreateQuote &&
                  _vm.savedLoadOptions.messageTypeId === _vm.messageTypes.QREQ
                    ? _c("span", [_vm._v("Quote created")])
                    : _vm.savedLoadOptions &&
                      !_vm.savedLoadOptions.isCreateQuote &&
                      _vm.savedLoadOptions.messageTypeId ===
                        _vm.messageTypes.QREQ
                    ? _c("span", [_vm._v("Quote assigned")])
                    : _c("span", [_vm._v("Message loaded")]),
                  _vm._v(" successfully. Go to quote "),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(`${_vm.quoteNo}`))]
                  ),
                  _vm._v(" now? "),
                ]
              ),
            ]
          ),
          _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isMessageOperationConfirmModalActive,
                "ok-text": "Yes",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isMessageOperationConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.changeMessageStatus(
                    _vm.selectedMessageId,
                    _vm.messageOperationTypeId
                  )
                },
                cancel: function ($event) {
                  _vm.isMessageOperationConfirmModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("PNET Message"),
              ]),
              _c(
                "div",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c("span", [_vm._v("Message will be moved to")]),
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getFolderName(_vm.messageOperationTypeId)) +
                        ". "
                    ),
                  ]),
                  _c("br"),
                  _c("span", [_vm._v("Are you sure?")]),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-email mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-email-open mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-send mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-checkbox-marked-circle mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-18px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }